/* eslint-disable no-undef */
import { FunctionComponent } from 'react';
import CourseLanding from './../../components/courseLanding';
import SectionTitle from './../../components/sectionTitle';
import Conversation from './conversation';
import Conversations from './conversations';
import Animation001 from './animation001';
import Animation004 from './animation004';
import Animation005 from './animation005';
import Animation006 from './animation006';
import Animation008 from './animation008';
import Animation009 from './animation009';
import Animation011 from './animation011';
import Animation012 from './animation012';
import Animation013 from './animation013';
import Quiz from './../../components/quiz';
import Component001 from './component001';
import Component002 from './component002';
import Component003 from './component003';
import Component004 from './component004';
import Component006 from './component006';
import Component007 from './component007';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Conversations,
  Animation001,
  Animation004,
  Animation005,
  Animation006,
  Animation008,
  Animation009,
  Animation011,
  Animation012,
  Animation013,
  Component001,
  Component002,
  Component003,
  Component004,
  Component006,
  Component007,
};

export default Components;
